import * as React from 'react'

import { observer } from 'mobx-react'

import type { InboxRequest } from 'modules/notifications/hooks/useNotificationsRequests'

import EndedHiringInUnterminatedEmployee from './CustomContent/EndedHiringUnterminatedEmployee'
import AtsApprovals from './CustomContent/PendingApprovals/AtsApprovals'
import AttendanceApprovals from './CustomContent/PendingApprovals/AttendanceApprovals'
import BankingCardRequests from './CustomContent/PendingApprovals/BankingCardRequests'
import CardApprovals from './CustomContent/PendingApprovals/CardApprovals'
import ExpensesApprovals from './CustomContent/PendingApprovals/ExpensesApprovals'
import PurchaseApprovals from './CustomContent/PendingApprovals/PurchaseApprovals'
import SwapShiftRequests from './CustomContent/PendingApprovals/SwapShiftRequests'
import TimeoffAprovals from './CustomContent/PendingApprovals/TimeoffApprovals'
import TrainingRequestApprovals from './CustomContent/PendingApprovals/TrainingRequestApprovals'
import PendingQuestionGroupEnps from './CustomContent/PendingQuestionGroupEnps'
import { CUSTOM_REQUESTS_TYPES } from './CustomRequestsTypes'
import Request from './Request'
import type { RequestComponent } from './base'

import './index.styles.css'

interface Props {
  request: InboxRequest
  index: number
  compact?: boolean
  // Remove the request with the passed 'id' from the list if
  // the passed 'id' is found
  removeRequestById: (id: string) => void
}

const CUSTOM_COMPONENTS: Record<string, RequestComponent> = {
  [CUSTOM_REQUESTS_TYPES.timeoff_leave]: TimeoffAprovals,
  [CUSTOM_REQUESTS_TYPES.expenses_expensable]: ExpensesApprovals,
  [CUSTOM_REQUESTS_TYPES.ended_hiring_in_unterminated_employees]: EndedHiringInUnterminatedEmployee,
  [CUSTOM_REQUESTS_TYPES.pending_enps]: PendingQuestionGroupEnps,
  [CUSTOM_REQUESTS_TYPES.ats_requisition]: AtsApprovals,
  [CUSTOM_REQUESTS_TYPES.expenses_card]: CardApprovals,
  [CUSTOM_REQUESTS_TYPES.purchase_request_approvals]: PurchaseApprovals,
  [CUSTOM_REQUESTS_TYPES.training_request_approvals]: TrainingRequestApprovals,
  [CUSTOM_REQUESTS_TYPES.attendance_edit_timesheet_request_approvals]: AttendanceApprovals,
  [CUSTOM_REQUESTS_TYPES.banking_card]: BankingCardRequests,
  [CUSTOM_REQUESTS_TYPES.swap_shift_request_approvals]: SwapShiftRequests,
}

const CUSTOM_COMPACT_COMPONENTS: Record<string, RequestComponent> = {
  [CUSTOM_REQUESTS_TYPES.timeoff_leave]: TimeoffAprovals,
  [CUSTOM_REQUESTS_TYPES.ended_hiring_in_unterminated_employees]: EndedHiringInUnterminatedEmployee,
}

export const RequestItem = observer(
  ({ request, index, compact = false, removeRequestById }: Props) => {
    const type = String(request.type)

    const isCustomComponentForInbox = () => {
      return Object.keys(CUSTOM_COMPONENTS).includes(type) && !compact
    }

    const isCustomComponentForCompact = () => {
      return Object.keys(CUSTOM_COMPACT_COMPONENTS).includes(type) && compact
    }

    if (isCustomComponentForInbox() || isCustomComponentForCompact()) {
      const Component = CUSTOM_COMPONENTS[type] as RequestComponent

      return (
        <Component
          request={request}
          index={index}
          compact={compact}
          removeRequestById={removeRequestById}
        />
      )
    }

    return (
      <Request
        request={request}
        index={index}
        compact={compact}
        removeRequestById={removeRequestById}
      />
    )
  }
)
